var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8302_38198)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8302_38198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6654 24.417C46.4478 24.417 47.082 25.0513 47.082 25.8337V27.2489L54.1654 27.2503V35.7503L51.3037 35.7489L55.2233 46.5103C55.4552 47.129 55.582 47.7992 55.582 48.4989C55.582 51.6285 53.045 54.1656 49.9154 54.1656C47.2758 54.1656 45.0578 52.3609 44.4279 49.9181L38.4032 49.9181C37.7738 52.3616 35.5554 54.167 32.9154 54.167C30.1601 54.167 27.8642 52.2006 27.3543 49.5947C26.4491 49.1223 25.832 48.175 25.832 47.0837V28.667C25.832 27.8846 26.4663 27.2503 27.2487 27.2503H37.1654C37.9478 27.2503 38.582 27.8846 38.582 28.667V40.0003C38.582 40.7268 39.1289 41.3256 39.8335 41.4075L39.9987 41.417H42.832C43.5585 41.417 44.1573 40.8701 44.2392 40.1655L44.2487 40.0003V27.2503H39.9987V24.417H45.6654ZM32.9154 45.667C31.3506 45.667 30.082 46.9355 30.082 48.5003C30.082 50.0651 31.3506 51.3337 32.9154 51.3337C34.4802 51.3337 35.7487 50.0651 35.7487 48.5003C35.7487 46.9355 34.4802 45.667 32.9154 45.667ZM49.9154 45.6656C48.3506 45.6656 47.082 46.9341 47.082 48.4989C47.082 50.0637 48.3506 51.3323 49.9154 51.3323C51.4802 51.3323 52.7487 50.0637 52.7487 48.4989C52.7487 46.9341 51.4802 45.6656 49.9154 45.6656ZM48.289 35.7489H47.082V40.0003C47.082 42.3475 45.1792 44.2503 42.832 44.2503H39.9987C38.1487 44.2503 36.5748 43.0683 35.991 41.4183L28.6653 41.417V44.7522C29.7036 43.5757 31.2228 42.8337 32.9154 42.8337C35.5559 42.8337 37.7747 44.6398 38.4036 47.084H44.4268C45.0552 44.6391 47.2743 42.8323 49.9154 42.8323C50.2515 42.8323 50.5808 42.8615 50.9009 42.9177L48.289 35.7489ZM35.7487 34.3337H28.6654V38.5837H35.7487V34.3337ZM51.332 30.0837H47.082V32.917H51.332V30.0837ZM35.7487 30.0837H28.6654V31.5003H35.7487V30.0837Z",
    fill: "#9E9EA8"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "black",
    strokeOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8302_38198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8302_38198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(23 23)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.131ba932b8ff4d7b3fce7293e29193ca.svg";
export { ForwardRef as ReactComponent };